<template>
  <div class="transaction-change-state-panel">
    <button class="delete is-large is-pulled-right" @click="close" />
    <p class="subtitle">Change State - {{ workflowType }}</p>

    <p>
      Current state: <b class="has-text-info">{{ t.state }}</b>
    </p>
    <div>
      <div class="list">
        <p v-for="s in states" :key="s" class="list-item" @click="preChangeState(s)">
          {{ s }}
          <i class="fa fa-chevron-right is-pulled-right" style="padding: 3px 0" />
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TransactionChangeStatePanel",
  props: {
    t: Object, // transaction
  },
  data() {
    return {
      deliveryStates: ["confirmed", "driver_arrived", "enroute", "alighted"],
      commerceStates: ["confirmed", "ready", "completed"],
      remitStates: ["ready", "pending", "completed"]
    };
  },
  computed: {
    workflowType() {
      return this.t.workflow_type_name;
    },
    states() {
      if (this.workflowType === "Remit") return this.remitStates;
      if (this.workflowType === "Commerce") return this.commerceStates;
      return this.deliveryStates;
    }
  },
  mounted() { },
  methods: {
    close() {
      this.$emit("close");
    },
    preChangeState(state) {
      this.$swal({
        html: `<div style='text-align:left'>
          <p>Change state from <b>${this.t.state}</b> 
            to <b>${state}</b>?</p>
          </div>`,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonColor: this.bulmaColor("success"),
        confirmButtonText: "Change",
      }).then((val) => {
        if (val.value) this.changeState(state);
      });
    },
    changeState(state) {
      var loader = this.loadingDots("pink");
      var payload = { id: this.t.id, state: state };
      this.$store
        .dispatch("forceChangeTransactionState", payload)
        .then((res) => {
          console.log("forceChangeTransactionState", res.data);
          this.successToast("Changed state to " + state);
          this.close();
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
  },
};
</script>

<style scoped>
.transaction-change-state-panel {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100vw;
  padding: 10px;
  background-color: #1f1b24;
  color: white;
  padding-bottom: 20px;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  box-shadow: 0 0 4px 4px white;
}

.subtitle {
  margin-bottom: 16px;
  color: #ccc;
}

.list {
  background-color: black;
  margin-top: 6px;
}

.list-item {
  color: white;
  border-bottom: 1px solid #333;
  padding: 12px;
}
</style>